"use client";
import React from "react";
import "./Hero.css";
import Email from "../Email/Email";
import { TypeAnimation } from "react-type-animation";
function Hero() {
  return (
    <div className="h-wrapper">
      <div className="container">
        <div className="h-container">
          <div className="h-right">
            <div className="h-title">
              <span>Mafkin Robotics</span>
              <span>Revolutionizing Hull cleaning</span>
              <TypeAnimation
                sequence={[
                  "60% increase in cleaning efficiency",
                  2000,
                  "20% increase in fuel efficiency",
                  2000,
                  "Standardized waste management",
                  2000,
                  "Protection of anti-fouling coating",
                  2000,
                ]}
                speed={50}
                wrapper="span"
                repeat={Infinity}
              />
            </div>
            <div className="h-dis">
              Mafkin Robotics addresses the inefficiencies of manual Ship hull
              cleaning by pioneering a fully autonomous cleaning solution
            </div>
            <Email />
            <div className="h-scroll-indicator">
              <div className="h-scroll-dot" />
              <span>Scroll</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
